module.exports = __webpack_public_path__ + "img/clienti_info.1b788430.png";